import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'hy',
    fullName: 'Armenian',
    nativeName: 'Հայերեն',
    direction: 'ltr'
};

const translations: LocaleData = {
    title: "ArgVoid",
    landing_title: "Ինչ-որ զարմանալի բան է գալիս",
    landing_subtitle: "ArgVoid-ը հավելվածների և խաղերի մշակման ստուդիա է: Հետևե՛ք, շուտով նոր բաներ են սպասվում:",
    select_language: "Ընտրեք Լեզուն",
    search_placeholder: "Լեզուների որոնում...",
    terms_title: "Ծառայության պայմաններ",
    policy_title: "Գաղտնիության քաղաքականություն",
    cookies_title: "Cookie քաղաքականություն",
    terms_content: `
        <strong>1. Պայմանների ընդունում</strong><br>
        Մուտք գործելով ArgVoid՝ ընդունվում են Ծառայության այս պայմանները: Եթե այս պայմանները համաձայնեցված չեն, ծառայությունը չպետք է օգտագործվի:<br><br>

        <strong>2. Պլատֆորմի օգտագործում</strong><br>
        ArgVoid-ը և դրա հավելվածները տրամադրվում են «ինչպես կա» տեղեկատվական և ստեղծագործական նպատակներով: Ծառայությունը պետք է օգտագործվի միայն օրինական նպատակներով։<br><br>

        <strong>3. Արգելված վարքագիծ</strong><br>
        Կայքի խոցելիության օգտագործումը, սպամը կամ ենթակառուցվածք չթույլատրված մուտքի փորձը խստիվ արգելված է:<br><br>

        <strong>4. Հրաժարում</strong><br>
        Պլատֆորմը և ծառայությունները կարող են փոփոխվել ցանկացած պահի առանց ծանուցման: Ոչ մի երաշխիք չի տրվում ծառայության ժամկետի կամ հասանելիության վերաբերյալ:
    `,
    policy_content: `
        <strong>1. Տեղեկությունների հավաքածու</strong><br>
        Պլատֆորմն այս պահին չի պահանջում օգտատիրոջ նույնականացում կամ հաշվի ստեղծում: Այցելուներից ակտիվորեն հավաքագրվում են ոչ մի անձնական նույնականացնող տեղեկատվություն (օրինակ՝ անուններ կամ էլ. հասցեներ):<br><br>

        <strong>2. Օգտագործեք Data</strong><br>
        Հիմնական, անանուն վերլուծությունները կարող են հավաքվել՝ կայքի տրաֆիկը հասկանալու և հավելվածները բարելավելու համար: Այս տվյալները կապված չեն առանձին օգտատերերի ինքնության հետ:<br><br>

        <strong>3. Երրորդ կողմի ծառայություններ</strong><br>
        Երրորդ կողմի մատակարարները կարող են օգտագործվել հոսթինգի և վերլուծական ծառայությունների համար: Այս համապատասխան մատակարարների գաղտնիության պրակտիկան կարգավորում է իրենց ենթակառուցվածքում մշակված անանուն տվյալները:<br><br>

        <strong>4. Տվյալների անվտանգություն</strong><br>
        Պլատֆորմը պաշտպանելու համար իրականացվում են անվտանգության ողջամիտ միջոցառումներ: Այնուամենայնիվ, ինտերնետի միջոցով փոխանցման ոչ մի մեթոդ լիովին անվտանգ չէ:<br><br>
    `,
    cookies_content: `
        <strong>1. Ի՞նչ են թխուկները և տեղային պահեստը:</strong><br>
        Թխուկները և բրաուզերի տեղական պահեստը փոքր տվյալների ֆայլեր են, որոնք պահվում են սարքում՝ այցելությունների ընթացքում կազմաձևման նախապատվությունները հիշելու համար:<br><br>

        <strong>2. Օգտագործման նպատակը</strong><br>
        Browser LocalStorage-ը խստորեն օգտագործվում է կոնֆիգուրացիայի կարգավորումները պահպանելու համար, օրինակ՝ <br>
        - Լեզվի նախապատվություններ<br>
        - Օգտագործողի միջերեսի կազմաձևում (օրինակ՝ դասավորության կամ թեմայի կարգավորումներ) <br>
        - Ժամանակավոր հավելվածի քեշ<br><br>

        <strong>3. Ոչ մի Հետևում</strong><br>
        Թխուկները և տեղական պահեստը չեն օգտագործվում գովազդի կամ երրորդ կողմի հետագծման նպատակով: Բոլոր պահված տվյալները խստորեն նախատեսված են հարթակի հիմնական գործառույթների համար:<br><br>

        <strong>4. Control</strong><br>
        Բրաուզերի տվյալները կարող են ցանկացած պահի մաքրվել բրաուզերի կարգավորումների միջոցով, ինչը կվերակայի տեղական ցանկացած կոնֆիգուրացիա:
    `,
    cookie_consent_text: "Մենք օգտագործում ենք հիմնական թխուկներ՝ ապահովելու վեբկայքի ճիշտ գործառույթները, ինչպես օրինակ՝ ձեր աշխատաշրջանը ակտիվ պահելը, ձեր լեզվի նախապատվությունը պահպանելը և այլ հատուկ կոնֆիգուրացիաներ:",
    read_policy: "Կարդացեք թխուկների քաղաքականությունը",
    support_title: "Կապվեք աջակցության հետ",
    support_subject_label: "Թեմա",
    support_message_label: "Հաղորդագրություն",
    support_submit_button: "Ուղարկել հաղորդագրություն",
    support_hint: "Նշում․ սա կբացի ձեր կանխադրված էլփոստի հավելվածը՝ հաղորդագրություն ուղարկելու համար:",
    support_success_msg: "Ձեր էլփոստի հավելվածը բացվում է...",
    support_error_msg: "Չհաջողվեց ուղարկել հաղորդագրություն: Խնդրում ենք փորձել ավելի ուշ:",
    explorer_title: "Explorer",
    history_title: "Պատմություն",
    animation_title: "Անիմացիա",
    config_title: "Կոնֆիգուրացիա",
    tool_mouse: "Ընտրել (Ctrl+M)",
    tool_brush: "Վրձին (Ctrl+B)",
    tool_brush_mode: "Միացնել ռեժիմը (պինդ/մաքուր)",
    tool_eraser: "Ռետին (Ctrl+E)",
    tool_brush_size: "Կարգավորեք խոզանակի չափը",
    tool_bucket: "Լրացնել (Ctrl+F)",
    tool_eyedropper: "Աչքի կաթիլ",
    tool_grid: "Ցանց (Ctrl+Shift+B)",
    tool_rotate: "Պտտել (Ctrl+Shift+R)",
    tool_flip_h: "Շրջել H (Ctrl+Shift+H)",
    tool_flip_v: "Շրջել V (Ctrl+Shift+V)",
    tool_transpose: "Փոխադրել (Ctrl+Shift+T)",
    label_width: "Լայնությունը",
    label_height: "Բարձրություն",
    label_frames: "Շրջանակների քանակը",
    label_animation: "Անիմացիոն ոճ",
    label_background_color: "Ֆոնի գույնը",
    label_interval: "Ինտերվալ",
    tool_anim_config: "Անիմացիայի կոնֆիգուրացիա",
    label_new_width: "Նոր լայնություն",
    label_new_height: "Նոր Բարձրություն",
    label_apply: "Դիմել",
    label_colors: "Գույներ",
    label_size: "Չափը",
    label_tolerance: "Հանդուրժողականություն",
    val_horizontal: "Հորիզոնական",
    val_vertical: "Ուղղահայաց",
    val_sequence: "Հերթականություն",
    val_bounce: "Ցատկել",
    val_random: "Պատահական",
    val_solid: "Պինդ",
    val_clear: "Պարզ",
    action_add_sheet: "Նոր թերթիկ",
    action_import: "Ներմուծում",
    action_export: "Արտահանում",
    action_sort_projects: "Տեսակավորել",
    sort_date_old: "Ամենահին Առաջինը",
    sort_date_new: "Նորագույն Առաջին",
    sort_name_az: "Անունը (A-Z)",
    sort_name_za: "Անունը (Z-A)",
    action_new_sprite: "Նոր Sprite",
    action_new_project: "Նոր նախագիծ",
    modal_save_all_title: "Պահպանել բոլոր փոփոխությունները",
    modal_save_all_desc: "Ընտրեք ակտիվները, որոնք պետք է պահպանվեն.",
    modal_save_selected: "Պահպանել ընտրվածը",
    action_saved: "Պահպանված է",
    modal_create_sprite_title: "Ստեղծեք նոր Sprite",
    modal_create_project_title: "Ստեղծել նոր նախագիծ",
    modal_add_sheet_title: "Ավելացնել նոր թերթ",
    modal_rename_sheet_title: "Վերանվանել թերթիկը",
    modal_rename_sprite_title: "Վերանվանել Sprite-ը",
    modal_delete_sprite_title: "Ջնջել Sprite-ը",
    modal_delete_project_title: "Ջնջել նախագիծը",
    modal_delete_sheet_title: "Ջնջել թերթիկը",
    placeholder_sprite_name: "Անուն",
    placeholder_project_name: "Անուն",
    placeholder_sheet_name: "Անուն",
    placeholder_new_name: "Նոր անուն",
    action_create: "Ստեղծել",
    action_add: "Ավելացնել",
    action_rename: "Վերանվանել",
    action_duplicate: "Կրկնօրինակեք",
    action_delete: "Ջնջել",
    action_cancel: "Չեղարկել",
    confirm_delete_sprite: "Իսկապե՞ս ուզում եք ջնջել այս սփրայթը:",
    confirm_delete_project: "Իսկապե՞ս ուզում եք ջնջել այս նախագիծը: Բոլոր սփրայթները կհեռացվեն:",
    confirm_delete_sheet: "Իսկապե՞ս ուզում եք ջնջել այս թերթիկը:",
    err_select_sprite: "Խնդրում ենք նախ ընտրեք սփրայթ:",
    err_select_project: "Խնդրում ենք նախ ընտրել նախագիծ:",
    err_name_empty: "Անունը չի կարող դատարկ լինել:",
    err_sprite_exists: "Այդ անունով սփրայթն արդեն գոյություն ունի:",
    err_project_exists: "Այդ անունով նախագիծ արդեն գոյություն ունի։",
    err_no_content: "Պահելու բովանդակություն չկա:",
    err_no_changes: "Փոփոխություններ չկան պահելու համար:",
    err_delete_last_sheet: "Հնարավոր չէ ջնջել վերջին թերթիկը:",
    err_extract_frames: "Չհաջողվեց դուրս հանել որևէ շրջանակ:",
    err_indexeddb: "Չհաջողվեց պահել տեղում: Ձեր դիտարկիչը կարող է չաջակցել IndexedDB-ին:",
    msg_upload_success: "Վերբեռնումը հաջողվեց՝ {0}",
    msg_upload_failed: "Չհաջողվեց վերբեռնել՝ {0}",
    msg_save_success: "Պահպանել հաջողակ:",
    msg_saving: "Պահվում է...",
    msg_multi_save_result: "Պահված {0} ակտիվներ: {1} ձախողումներ:",
    menu_title: "Մենյու",
    menu_save: "Պահպանել",
    menu_save_all: "Պահպանել բոլորը",
    menu_support: "Կապվեք աջակցության հետ",
    label_local_storage: "Տեղական պահեստ",
    label_sign_in: "Մուտք գործեք",
    modal_export_title: "Արտահանել Sprite",
    label_filename: "Ֆայլի անունը",
    label_format: "Ձևաչափ",
    action_export_confirm: "Արտահանում",
};

export default translations;
